import { debounce } from 'lodash-es'
import { useEffect, useId } from 'react'

declare global {
  interface Window {
    Intercom?: (command: string, ...args: any[]) => void
  }
}

export function useIntercomUtils(hide = false) {
  const id = useId()

  useEffect(() => {
    hideByComponent.set(id, hide)
    update(Array.from(hideByComponent.values()).some(v => v))
  }, [hide])
}

const hideByComponent = new Map<string, boolean>()

const update = debounce((hide: boolean) => {
  window.Intercom?.('update', { z_index: hide ? -10 : 1000000 })
}, 100)

export function sendIntercomMessage(message: string) {
  if (typeof window !== 'undefined' && window.Intercom) {
    window.Intercom('showNewMessage', message)
  } else {
    console.warn('Intercom is not available')
  }
}
